/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
export class BarChartGroupedLayout {}
BarChartGroupedLayout.BAR_SIZE = 0.5;
BarChartGroupedLayout.BAR_GAP = 0.125;
BarChartGroupedLayout.MIN_GROUP_DISTANCE = 1.5;
BarChartGroupedLayout.MAX_GROUP_DISTANCE = 20.0;
